import { render, staticRenderFns } from "./SkuHistory.vue?vue&type=template&id=6c6f340c&scoped=true&"
import script from "./SkuHistory.vue?vue&type=script&lang=js&"
export * from "./SkuHistory.vue?vue&type=script&lang=js&"
import style0 from "./SkuHistory.vue?vue&type=style&index=0&id=6c6f340c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c6f340c",
  null
  
)

export default component.exports